// Lazy loader + synchronous cache for the large (~500KB source)
// marketingPages.js content module, which is intentionally kept OUT of the
// main bundle (nothing may import './marketingPages' statically from
// main-bundle code - only via the dynamic import below).
//
// Why a synchronous cache instead of plain import(): react-snap prerenders
// every marketing route to static HTML with the full page content. When a
// real visitor hydrates that HTML, the very first client render must produce
// the same full content, or React discards the prerendered DOM and the page
// flashes empty. index.js therefore awaits preloadMarketingPages() BEFORE
// mounting when the visitor lands directly on a marketing route, so
// MarketingPage can read the data synchronously (getLoadedMarketingPages)
// on its first render and hydration matches.
//
// For client-side navigations (visitor arrived on a different route, cache
// still cold) MarketingPage falls back to loading the chunk on demand -
// there is nothing prerendered on screen in that case, so a brief blank
// state is harmless.
let loadedModule = null;
let loadPromise = null;

function preloadMarketingPages() {
    if (!loadPromise) {
        loadPromise = import(
            /* webpackChunkName: "marketing-pages-data" */ './marketingPages'
        ).then((mod) => {
            loadedModule = mod;
            return mod;
        });
    }
    return loadPromise;
}

function getLoadedMarketingPages() {
    return loadedModule;
}

export { preloadMarketingPages, getLoadedMarketingPages };
